(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-showcase"] && !Shopify.designMode) return;
  try {
    class ProductShowcase {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-showcase-track]');
      this.dots = Array.from(root.querySelectorAll('[data-showcase-dot]'));
      if (!this.track) return;

      const prev = root.querySelector('[data-showcase-prev]');
      const next = root.querySelector('[data-showcase-next]');

      if (prev) prev.addEventListener('click', () => this.scrollByDir(-1));
      if (next) next.addEventListener('click', () => this.scrollByDir(1));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToIndex(index));
      });

      this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });

      this.initSizeModal();
    }

    initSizeModal() {
      const trigger = this.root.querySelector('[data-size-open]');
      const modal = this.root.querySelector('[data-size-modal]');
      if (!trigger || !modal) return;

      const open = () => {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      const close = () => {
        modal.hidden = true;
        document.body.style.overflow = '';
      };

      trigger.addEventListener('click', open);
      modal.querySelectorAll('[data-size-close]').forEach((el) => {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) close();
      });
    }

    get slideWidth() {
      return this.track.clientWidth;
    }

    get currentIndex() {
      return Math.round(this.track.scrollLeft / this.slideWidth);
    }

    scrollByDir(direction) {
      this.scrollToIndex(this.currentIndex + direction);
    }

    scrollToIndex(index) {
      const max = this.track.children.length - 1;
      const clamped = Math.max(0, Math.min(index, max));
      this.track.scrollTo({ left: clamped * this.slideWidth, behavior: 'smooth' });
    }

    syncDots() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        const active = this.currentIndex;
        this.dots.forEach((dot, index) => {
          if (index === active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      });
    }
  }

  function initShowcases() {
    document.querySelectorAll('[data-showcase]').forEach((root) => {
      if (root.dataset.showcaseReady) return;
      root.dataset.showcaseReady = 'true';
      new ProductShowcase(root);
    });
  }

  if (document.readyState !== 'loading') {
    initShowcases();
  } else {
    document.addEventListener('DOMContentLoaded', initShowcases);
  }
  document.addEventListener('shopify:section:load', initShowcases);
  } catch(e) { console.error(e); }
})();

})();
